import type {
  IChartApi,
  IPrimitivePaneRenderer,
  ISeriesPrimitive,
  SeriesAttachedParameter,
  Time,
  UTCTimestamp,
} from 'lightweight-charts';

type Target = Parameters<IPrimitivePaneRenderer['draw']>[0];

/** MT5's period separators: dotted vertical lines, behind the candles, at the times given. */
export class SeparatorsPrimitive implements ISeriesPrimitive<Time> {
  private chart: IChartApi | null = null;
  private redraw: (() => void) | null = null;
  private times: number[] = [];
  private color = '#888888';

  attached(param: SeriesAttachedParameter<Time>) {
    this.chart = param.chart as IChartApi;
    this.redraw = param.requestUpdate;
  }

  detached() {
    this.chart = null;
    this.redraw = null;
  }

  set(times: number[], color: string) {
    this.times = times;
    this.color = color;
    this.redraw?.();
  }

  paneViews() {
    return [
      {
        zOrder: () => 'bottom' as const,
        renderer: (): IPrimitivePaneRenderer => ({
          draw: (target: Target) => {
            const chart = this.chart;
            if (!chart || this.times.length === 0) return;
            target.useMediaCoordinateSpace(({ context, mediaSize }) => {
              context.save();
              context.strokeStyle = this.color;
              context.globalAlpha = 0.6;
              context.lineWidth = 1;
              context.setLineDash([2, 3]);
              for (const t of this.times) {
                const x = chart.timeScale().timeToCoordinate(t as UTCTimestamp);
                if (x === null) continue;
                const px = Math.round(x) + 0.5;
                context.beginPath();
                context.moveTo(px, 0);
                context.lineTo(px, mediaSize.height);
                context.stroke();
              }
              context.restore();
            });
          },
        }),
      },
    ];
  }
}
